import { render, staticRenderFns } from "./PizzaAdmin.vue?vue&type=template&id=18aed6df&"
import script from "./PizzaAdmin.vue?vue&type=script&lang=js&"
export * from "./PizzaAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports